import React from "react";
import PropTypes from "prop-types";
//Material imports
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
// Limitless imports
import { useTranslation } from "@limitless/common/hooks";
import { LoginButton } from "@limitless/portal";
import { verifySignUpScreenStyles } from "../styles/verifySignup";
import CodeCollector from "@limitless/portal/components/code-collector/CodeCollector";
import { useVerify } from "@limitless/content/hooks/VerifyHook";
const Anchor = ({
  t,
  text,
  color,
  onClick
}) => {
  return /*#__PURE__*/React.createElement(Link, {
    color: color ? color : "textSecondary",
    style: {
      cursor: "pointer"
    },
    key: "ResendSignUpCode",
    onClick: onClick
  }, "   ", /*#__PURE__*/React.createElement("span", {
    style: {
      fontWeight: 500
    }
  }, " ", t(text), " "));
};
const SignUpForm = ({
  email
}) => {
  const classes = verifySignUpScreenStyles();
  const {
    t
  } = useTranslation();
  const {
    maxLength,
    clearCodes,
    verifySignUpState,
    verifyButtonHandler,
    resendButtonHandler,
    updateCodeCollector
  } = useVerify();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    component: Typography,
    variant: "h2",
    color: "textPrimary"
  }, t("Verify your email address")), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Grid, {
    component: Typography,
    variant: "h6",
    color: "textPrimary"
  }, t("Before you access the platform, we need to verify email address. We’ve sent a verification code to {0}", email)), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Grid, {
    component: Typography,
    variant: "h6",
    color: "textPrimary"
  }, t("Please enter the below code")), /*#__PURE__*/React.createElement(Grid, {
    component: Typography,
    variant: "h6",
    color: "textPrimary",
    style: {
      marginTop: 50,
      marginBottom: 50
    }
  }, /*#__PURE__*/React.createElement(CodeCollector, {
    clearAll: clearCodes,
    classes: classes,
    max: maxLength,
    onUpdate: updateCodeCollector
  })), /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(LoginButton, {
    style: {
      marginTop: 20,
      marginBottom: 10
    },
    loading: verifySignUpState.loading,
    component: "button",
    disabled: !verifySignUpState.btnVisible,
    id: "startEarningNowButton2",
    onClick: verifyButtonHandler(email)
  }, t("Verify"))), !verifySignUpState.loading ? /*#__PURE__*/React.createElement(Grid, {
    item: true,
    style: {
      marginTop: 20
    },
    xs: 12
  }, verifySignUpState.verifyFailed && /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement("p", {
    style: {
      color: "red"
    }
  }, t("The verification code is not valid."))), /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement("p", {
    style: {
      color: "red"
    }
  }, t("Please try again or "), /*#__PURE__*/React.createElement(Anchor, {
    onClick: resendButtonHandler(email),
    t: t,
    text: t("Resend"),
    color: "red"
  })))), /*#__PURE__*/React.createElement(Grid, null, verifySignUpState.errTxt ? /*#__PURE__*/React.createElement("p", {
    style: {
      color: "red"
    }
  }, verifySignUpState.errTxt) : /*#__PURE__*/React.createElement(React.Fragment, null, verifySignUpState.checkEmail ? t("Please check your email for new code") : verifySignUpState.verifyFailed ? "" : /*#__PURE__*/React.createElement(React.Fragment, null, t("Didn't get the code?"), /*#__PURE__*/React.createElement(Anchor, {
    onClick: resendButtonHandler(email),
    t: t,
    text: t("Resend")
  }))))) : "")));
};
export default SignUpForm;
SignUpForm.propTypes = {
  email: PropTypes.string.isRequired
};
Anchor.propTypes = {
  email: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  text: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func
};